import axios from 'axios';
import TokenService from '../services/token.service';

// const host = 'http://localhost:8081';
const host = process.env.REACT_APP_API_URL as string;

const client = axios.create({
  baseURL: `${host}/api/`,
  headers: {
    'Content-type': 'application/json',
  },
});

export const setLanguageHeader = (language: string) => (client.defaults.headers.common['x-language'] = language);
export const updateHeaderAuthorizationToken = (token: string) => (client.defaults.headers.common['Authorization'] = `Bearer ${token}`);
client.defaults.headers.common['x-requested-with'] = window.location.origin;
updateHeaderAuthorizationToken(TokenService.getLocalAccessToken());

client.interceptors.response.use(
  config => config,
  error => {
    const originalConfig = error.config;
    if (originalConfig.url !== '/auth/login' && error.response) {
      // Access Token was expired
      if (error.response.status === 401 && !originalConfig._retry) {
        const refreshToken = TokenService.getLocalRefreshToken();
        originalConfig._retry = true;
        return client
          .post(`${host}/api/auth/refresh`, { refreshToken }, originalConfig)
          .then(async rs => {
            const { accessToken, refreshToken } = rs.data;
            await TokenService.updateLocalAccessToken(accessToken);
            await TokenService.updateLocalRefreshToken(refreshToken);
            return accessToken;
          })
          .then(token => {
            updateHeaderAuthorizationToken(token);
            originalConfig.headers.Authorization = `Bearer ${token}`;
            return client(originalConfig);
          })
          .catch(() => {
            window.location.href = '/auth';
          });
      }
    }

    return Promise.reject(error);
  },
);

export default client;
